var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91696 8.06001C5.01657 8.54785 6.32623 8.52135 7.44777 7.87383C9.31112 6.79803 9.94955 4.41538 8.87374 2.55203L8.75916 2.35356M2.12575 6.44792C1.04994 4.58457 1.68837 2.20191 3.55172 1.12611C4.67326 0.47859 5.98292 0.452095 7.08253 0.939928M1.14258 6.48625L2.39477 6.82178L2.73029 5.56959M8.26931 3.43011L8.60483 2.17792L9.85702 2.51344",
    stroke: "#5CBBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.6b147dbb63770df744516cc5b4625fd1.svg";
export { ForwardRef as ReactComponent };